<div [class.slim]="slim"><ng-content></ng-content></div>
